// @flow

import { $set, update } from 'qim';

import { createLinkStateSync } from 'app/common/apollo/ApolloLinkStateSync';

type UpdateZapResultData = {
  id: string,
  title: string,
};

const handlers = {
  updateZap(state, result: UpdateZapResultData) {
    const { id, title } = result;
    return update(['flows', id, 'title', $set(title)], state);
  },
};

export const linkStateSync = createLinkStateSync(handlers);
